import { render, staticRenderFns } from "./testLogin.vue?vue&type=template&id=10c1f1fb&scoped=true"
import script from "./testLogin.vue?vue&type=script&lang=js"
export * from "./testLogin.vue?vue&type=script&lang=js"
import style0 from "./testLogin.vue?vue&type=style&index=0&id=10c1f1fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c1f1fb",
  null
  
)

export default component.exports